import React from 'react';

import cx from 'classnames';

import { ILink } from '../../TableOfContents/types';
import { getPrefix } from '../../utils';
import { NAVBAR_LINKS_CLASSNAME, useHorizontalAutoScroll, useNavigation } from './functions';
import s from './index.module.css';
import { LinkItem } from './LinkItem';

const NavBar = () => {
  const { links, activePageId } = useNavigation();

  useHorizontalAutoScroll(activePageId, links);

  return (
    <div className={cx(getPrefix('nav-bar'), s.navBar)} id="mobileNav">
      <>
        <div className={cx(s.wrapper, getPrefix(NAVBAR_LINKS_CLASSNAME))}>
          {links.map((link: ILink) => {
            return (
              <LinkItem
                key={link.id}
                link={link}
                isHidden={link.isHidden}
                onClick={link.onClick}
                activePageId={activePageId}
              />
            );
          })}
        </div>
      </>
    </div>
  );
};

export default NavBar;
